import { RefObject, useLayoutEffect } from 'react';
import { scrollWorkflowToTop } from './workflow-scroll.utils';

export const useWorkflowScrollReset = (overlayRef: RefObject<HTMLElement>, key: unknown): void => {
  useLayoutEffect(() => {
    scrollWorkflowToTop(overlayRef.current);
  }, [overlayRef, key]);
};
